import _ from 'underscore';
import { mapSegmentData } from './metric-mapper';

export const getSegmentedData = (data, keyPath) => {
  if (keyPath.length === 0) return [];

  if (Array.isArray(data)) {
    return _.flatten(data.map((item) => {
      const segmentedData = _.get(item, keyPath);
      return segmentedData ? mapSegmentData(segmentedData) : [];
    }));
  }

  let segmentedData = _.get(data, keyPath);

  if (!segmentedData && data?.DeviceSegmentedPerformanceData) {
    segmentedData = _.get(data.DeviceSegmentedPerformanceData, keyPath);
  }

  return segmentedData ? mapSegmentData(segmentedData) : [];
};
